// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

import { useState, useEffect } from 'react';

/**
 * Hook that waits for fonts to be loaded before allowing render.
 * Prevents FOUT (Flash of Unstyled Text) in development.
 */
export function useFontLoader(): boolean {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    // Check if fonts are already loaded
    if (document.fonts.status === 'loaded') {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setFontsLoaded(true);
      return;
    }

    // Wait for fonts to load
    document.fonts.ready.then(() => {
      setFontsLoaded(true);
    });
  }, []);

  return fontsLoaded;
}
